// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","body":"_2lYHSCAcM6vA2s-47YYZeS","paddedForNavbar":"_15-uIrn7gODHiOpUuDWjwC","title":"_3Gut2T6z4D4wrtdLYAe_nz _2IbHD4FVxtBnbNHEUw2mS3","genericContainer":"_2ELtkcMpIJZ1yyH_kfj3I7","mobileThreshold":"575px","container":"SELT3sCh9LkaMgPnfNVfp _15-uIrn7gODHiOpUuDWjwC","mainContent":"_1UJtkVla_9nREW0dC8WfMh _2ELtkcMpIJZ1yyH_kfj3I7","instructions":"mSm2tDgx_Cs4HM6i7uOHK _2lYHSCAcM6vA2s-47YYZeS","form":"_18zODaGNeMsK26ghHdnPyl"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/recover-account/RecoverAccount.css
// module id = 866
// module chunks = 0